import { AiModels, DOC_ANALYST_TABS } from 'src/types/enum';

export const APPS_NAV_LINK = {
  MINI_EXPERTS: '/apps',
  DOC_ANALYST: `/apps/doc-analyst/${DOC_ANALYST_TABS.ANALYSIS}`,
  SMART_MEET: '/apps/smart-meet',
  NEW_CHAT: '/chat',
  DATA_ANALYST: '/apps/data-analyst'
};

export const DATA_ANALYST_MODELS = [AiModels.gpt_5_6_luna];
